const Warehouse = () => import('@/views/warehouse')

export default [
  {
    path: '/warehouse/all',
    name: 'Armazéns',
    component: Warehouse,
  }
]
